<script>
    const axios = require('axios');
    import { useVuelidate } from '@vuelidate/core';
    import { required } from '@vuelidate/validators';
    import { discountStore } from './../store/discountStore.js';
    import { userStore } from './../store/userStore.js';
    import mixin from './../mixin.js';

    export default {
        props: {
            discountApi: {
                type: String,
                default: '/api/discounts'
            },
            kortingscodeTitle: {
                type: String,
                default: 'Kortingscode'
            },
            kortingscodePlaceholder: {
                type: String,
                default: 'Uw kortingscode'
            },
            kortingscodeButtonText: {
                type: String,
                default: 'check kortingscode'
            },
            kortingscodeSuccessText: {
                type: String,
                default: 'Kortingscode is juist'
            },
            kortingscodeFailText: {
                type: String,
                default: 'Kortingscode is niet juist'
            },
            kortingscodeRequiredText: {
                type: String,
                default: 'Kortingscode is verplicht'
            }
        },
        mixins: [mixin],
        setup() {
            return { v$: useVuelidate() }
        },
        data() {
            return {
                discountCode: '',
                loading: false,
                unvalidCode: false
            }
        },
        validations() {
            return {
                discountCode: { required }
            }
        },
        watch: {
            discountCode(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.unvalidCode = false;
                    this.v$.$reset();
                }
            }
        },
        computed: {
            discount() {
                return discountStore.state;
            },
            loggedIn() {
                return userStore.loggedIn;
            }
        },
        methods: {
            async checkCode() {
                const valid = await this.v$.$validate();
                if (!valid) return
                this.loading = true;
                let url = this.discountApi + '?code=' + this.discountCode;
                const discountResponse = await this.getData(url);
                this.loading = false;
                if (discountResponse.status === 200) {
                    if (discountResponse.data.length) {
                        this.unvalidCode = false;
                        discountStore.updateDiscount(discountResponse.data);
                    } else {
                        this.unvalidCode = true;
                    }
                }
            },
            async getData(url) {
                try {
                    const response = await axios({
                        method: 'get',
                        url: url,
                        headers: { "Content-Type": 'application/json' },
                    })
                    return response;
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<template>
    <div class="form">
        <div class="mb-5" v-if="loggedIn">
            <label class="label" for="discountcode">{{ kortingscodeTitle }}</label>
            <div class="has-text-centered" v-if="loading">
                <div class="loader"></div>
            </div>
            <div class="field has-addons" v-else>
                <div class="control is-flex-grow-1">
                    <input type="text" class="input is-radiusless" :placeholder="kortingscodePlaceholder" id="discountcode" name="discountcode" v-model="discountCode">
                </div>
                <div class="control">
                    <button class="button is-secondary" @click="checkCode()">{{ kortingscodeButtonText }}</button>
                </div>
            </div>
            <span class="form-error has-text-danger" v-if="v$.discountCode.$error">{{ kortingscodeRequiredText }}</span>
            <span class="form-error has-text-danger" v-if="unvalidCode">{{ kortingscodeFailText }}</span>
            <div class="content" v-else-if="discount.length">
                <p>{{ kortingscodeSuccessText }}</p>
            </div>
        </div>
    </div>
</template>